import { Collection } from 'modules/core/lib/mobx-rest'

import Period from 'modules/attendance/store/models/Period'

class Periods extends Collection<Period> {
  get cacheKey(): string {
    return 'periods'
  }

  model() {
    return Period
  }
}

const singleton: Periods = new Periods()

export default singleton
